'use strict'

angular.module('shiftTraderApp')
  .factory('TourService', ['$document', '$timeout', '$confirm', 'Session', function ($document, $timeout, $confirm, Session) {
    var activeTour = null
    var lastActiveTour = null

    // The keys of this object are the identifiers that are stored in the User
    // model whenever a tour is completed.
    var registeredTours = {
      'org-profile-tour': OrganizationProfileTour,
      'employee-profile-tour': EmployeeProfileTour
    }

    // Add events and actions to the registered tours.
    for (var tour in registeredTours) {
      registeredTours[tour].on('start', function (tour, idx) {
        activateShade()
      })
      registeredTours[tour].on('complete', function (tour, idx) {
        deactivateShade()
      })
      registeredTours[tour].on('cancel', function (tour, idx) {
        deactivateShade()
      })

      lodash.each(registeredTours[tour].steps, function (step, idx) {
        step.on('hide', removeAdvanceStepStyles)
        step.on('show', applyAdvanceStepStyles)

        for (var i = 0; i < step.options.buttons.length; i++) {
          var button = step.options.buttons[i]
          if (button.action === 'next') {
            button.action = nextStep
          } else if (button.action === 'previous') {
            button.action = previousStep
          } else if (button.action === 'finish') {
            button.action = finish
          }
        }
      })
    }

    // Internal Functions
    function applyAdvanceStepStyles () {
      if (!isTourActive()) {
        return
      }

      var step = Shepherd.activeTour.currentStep
      if (step.options.attachTo) {
        var el = $(step.options.attachTo.split(' ')[0])
        el.addClass('attached-shepherd-element')
      }

      if (step.options.extraStyles) {
        el.css(step.options.extraStyles)
      }
    }

    function removeAdvanceStepStyles (step) {
      var step = Shepherd.activeTour.currentStep
      if (step.options.attachTo) {
        var el = $(step.options.attachTo.split(' ')[0])
        el.removeClass('attached-shepherd-element')
        el.removeAttr('style')
      }
    }

    // Activated the modal-like shade over the application.
    function activateShade () {
      var shade = $('#shepherd-tour-shade')
      shade.addClass('in')
      $timeout(function () {
        shade.addClass('show')
      }, 100)

      var exitButton = shade.find('.exit-button')
      exitButton.on('click', function () {
        cancelActiveTour()
        $confirm({
          text: 'Would you like to see this tour again next time you visit this page?',
          ok: 'Yes, please.',
          cancel: 'No, I\'m good.'
        }).then(function () {},
        function () {
          Session.getMe()
            .then(function (me) {
              me.$finishTour(lastActiveTour)
            })
        })
      })
    }

    // Deactivates the modal-like shade over the application.
    function deactivateShade () {
      var shade = $('#shepherd-tour-shade')
      shade.removeClass('show')
      var exitButton = shade.find('.exit-button')
      exitButton.unbind('click')
      $timeout(function () {
        shade.removeClass('in')
      }, 250)
    }

    // Cancel the currently active tour.
    function cancelActiveTour () {
      if (isTourActive()) {
        Shepherd.activeTour.cancel()
        $document.unbind('keyup');
        lastActiveTour = activeTour
        activeTour = null
      }
    }

    // Returns true if a tour is currently active.
    function isTourActive () {
      return !!activeTour && !!Shepherd.activeTour
    }

    // Advance to the next step of the active tour.
    function nextStep () {
      if (!isTourActive()) {
        return
      }
      Shepherd.activeTour.next()
    }

    // Go back to the previous step in the active tour.
    function previousStep () {
      if (!isTourActive()) {
        return
      }
      Shepherd.activeTour.back()
    }

    // Complete currently active tour and mark is as such on the User model.
    function finish () {
      if (!isTourActive()) {
        return
      }

      Session.getMe()
        .then(function (me) {
          me.$finishTour(activeTour)
            .then(function () {
              lastActiveTour = activeTour
              activeTour = null
              Shepherd.activeTour.complete()
            }, function () {
              lastActiveTour = activeTour
              activeTour = null
              Shepherd.activeTour.cancel()
            })
        })
    }

    var tourService = {}
    tourService.startTour = function (tourName) {
      if (tourName) {
        if (isTourActive()) {
          cancelActiveTour()
        }

        activeTour = tourName
        registeredTours[activeTour].start()

        $document.bind('keyup', function(e) {
          if (e.keyCode === 27) {
            cancelActiveTour()
            e.preventDefault()
            e.stopPropagation()
          }
        })
      }

      tourService.getActiveTour = function() {
        return activeTour;
      }
    }

    return tourService
  }])
